import { api } from "./common";
import { Id, Team } from "../types";
import { fetchOrgEntities } from "./fetch-org-entities";

type Props = { subscriptionId: Id } & Pick<Team, "id">;

export const deleteTeam = async (props: Props) => {
  await api(`v2/teams/${props.id}`, {
    method: "DELETE",
    headers: { subscriptionid: props.subscriptionId.toString() },
  });

  const { teams } = await fetchOrgEntities(props.subscriptionId);

  return { teams };
};
